<template>
  <div id="top">
    <headNav :gray="gray"></headNav>
    <!--container-->
    <div class="innerWrapper">
      <h1>Privacy Policy</h1>
      <h2>
        This policy describes how Unifi Property Pty Ltd (ACN 638 376 977) (
        <i>Unifi, we us </i>or <i>our</i>) collects, manages, stores, uses and
        discloses your personal information. It contains the broad privacy
        framework within which we operate, and should be read in conjunction
        with any:
      </h2>
      <div>
        <p>supplementary privacy policies; and</p>
        <p>implementation procedures,</p>
      </div>
      <h2>that we introduce or vary from time to time.</h2>
      <h2>
        If you do not agree with the terms of this policy, please do not provide
        us with your personal information.
      </h2>
      <h3>DEFINITIONS</h3>
      <h2>
        To explain some of the terminology which commonly appears in this
        policy:
      </h2>
      <h2 class="wai">Information and records</h2>
      <h2>
        nformation and records may be in electronic or hard copy form. This
        policy does not extend to information or records that are publicly
        available, or that would constitute an “employee record” as defined by
        the Privacy Act 1988 (Cth) (<i>Privacy Act</i>).
      </h2>
      <h2 class="wai">Sensitive information</h2>
      <h2>
        Sensitive information is an important type of personal information
        relating to your:
      </h2>
      <div>
        <p>biometrics;</p>
        <p>criminal record;</p>
        <p>genetics;</p>
        <p>health;</p>
        <p>membership of a political association;</p>
        <p>membership of a professional or trade association;</p>
        <p>membership of a trade union;</p>
        <p>philosophical beliefs;</p>
        <p>political opinions;</p>
        <p>racial or ethnic origin;</p>
        <p>religious beliefs or affiliations; or</p>
        <p>sexual orientation or practices.</p>
      </div>
      <h3>HOW DOES UNIFI COLLECT AND HOLD PERSONAL INFORMATION?</h3>
      <h2>We collect personal information in a number of ways, including:</h2>
      <div>
        <p>
          directly from you, via email, telephone, post, when you provide
          details for our mailing lists, purchase our services, place a
          reservation for available properties, participate in our promotions,
          create a referral account for our website or when you join one of our
          clubs or programs; and
        </p>
        <p>
          from third parties to whom you make payments in connection with our
          reservations or services, or to whom you provide personal details in
          connection with the receipt of marketing materials. This includes
          third parties who you authorise to provide us with personal
          information.
        </p>
      </div>
      <h2>
        Cookies [<span class="red"
          >Website developer to review and confirm accuracy of description under
          “Cookies” section]</span
        >
      </h2>
      <h2>
        Our website uses 'cookies' to improve your browser experience. Cookies
        are small text files that are downloaded and stored onto your computer's
        browser directory when you visit a particular website. By using our
        website, you consent to our use of cookies.
      </h2>
      <h2>
        Cookies are used to track the pages and services you visit on our
        website and to ensure that you are able to move freely across our
        website without the need to re-enter information that you have already
        provided.
      </h2>
      <h2>We use cookies to collect information including:</h2>
      <div>
        <p>your computer's IP address and other technical information;</p>
        <p>
          the date and time at which you access our website and the duration of
          your visit;
        </p>
        <p>the pages and content that you viewed during your visit; and</p>
        <p>the type of browser you are using.</p>
      </div>
      <h2>
        It is possible to disable cookies by adjusting your Internet browser's
        setting, such that it refuses cookies. However, our website may not
        function correctly in the event that your browser refuses cookies. For
        an optimal browsing experience, we recommend that you allow the use of
        cookies.
      </h2>
      <h2 class="wai">Personal information</h2>
      <h2>We will only solicit and collect personal information if:</h2>
      <div>
        <p>
          it is reasonably necessary in order for us to provide our services and
          conduct our functions and activities; or
        </p>
        <p>we are permitted to do so by law.</p>
      </div>
      <h2 class="wai">Sensitive information</h2>
      <h2>We will only solicit and collect sensitive information if:</h2>
      <div>
        <p>
          we have your consent, and it is reasonably necessary for us to collect
          sensitive information to enable us to carry out relevant functions or
          activities; or
        </p>
        <p>we are permitted to do so by law.</p>
      </div>
      <h3>WHAT TYPES OF PERSONAL INFORMATION DOES UNIFI COLLECT AND HOLD?</h3>
      <h2>
        Depending upon how you interact with us, we may collect the following
        types of personal information from you:
      </h2>
      <div>
        <p>your name, gender and date of birth;</p>
        <p>your email address;</p>
        <p>your occupation, job title and place of business;</p>
        <p>the technology you use to access our services;</p>
        <p>your residential and postal address;</p>
        <p>telephone numbers;</p>
        <p>your company name and Australian Business Number; or</p>
        <p>your superannuation fund details.</p>
      </div>
      <h2>
        You may refuse to provide personal information to us. However, if you
        exercise this right of refusal, it may affect our ability to meet our
        obligations to you or to a third-party agency.
      </h2>
      <h2>
        You may also deal with us anonymously or by using a pseudonym. However,
        if you do so, we may be prevented from providing you with accurate or
        useful information, and you may not be able to access our full range of
        services.
      </h2>
      <h3>
        WHY DOES UNIFI COLLECT, HOLD, USE AND DISCLOSE PERSONAL INFORMATION?
      </h3>
      <h2>
        We may collect, hold and use your personal information for a number of
        reasons including:
      </h2>
      <div>
        <p>
          to provide information in relation to our services and available
          properties marketed for sale by our related companies and business
          associates, including those we consider may be of interest to you in
          the future;
        </p>
        <p>
          to administer and manage processes which are key to our operations,
          such as processing reservations of available properties or orders for
          our services;
        </p>
        <p>
          to effect the collection of money that you owe to us and to support
          auditing, compliance and other corporate governance functions;
        </p>
        <p>
          to assess any application for employment during the recruitment
          process;
        </p>
        <p>to assess your creditworthiness;</p>
        <p>
          to create an online referral account for you to access our website;
        </p>
        <p>
          to determine your eligibility for certain types of goods or services
          that may be of interest to you;
        </p>
        <p>
          to answer your queries, provide you with information you may have
          requested and generally conduct dealings with you; and
        </p>
        <p>to comply with legislative or other legal requirements.</p>
      </div>
      <h2>
        We may disclose your personal information for a number of reasons
        including:
      </h2>
      <div>
        <p>
          to identify you and verify your age, identity and corporate
          information;
        </p>
        <p>
          to provide our services to you, or the organisation that you
          represent;
        </p>
        <p>to improve our website and the services that we provide;</p>
        <p>to communicate with you; and</p>
        <p>
          for other purposes which are related, or directly related (in the case
          of sensitive information), to the purpose for which your information
          was initially collected.
        </p>
      </div>
      <h2>We may disclose your personal information to:</h2>
      <div>
        <p>
          our related parties, including Varo Property Services Pty Ltd ACN 606
          239 641;
        </p>
        <p>
          other companies or individuals that assist us to provide our
          reservations and other services, or to administer our internal
          operations. This includes:
        </p>
        <p class="suojin">
          electronic transactions / payment service providers, to process
          reservations and other orders for our services;
        </p>
        <p class="suojin">
          online booking service providers, to process bookings for our
          services;
        </p>
        <p class="suojin">
          government authorities or other agencies where the disclosure is
          required or authorised by law;
        </p>
        <p class="suojin">
          anyone else to whom you authorise us to disclose your personal
          information;
        </p>
        <p class="suojin">
          prospective purchasers of all or some of our business or assets, in
          the event of a merger, re-organisation or sale of our business or
          assets;
        </p>
        <p class="suojin">
          information technology / cloud service providers, such as persons who
          develop any of the software used by our business; and
        </p>
        <p class="suojin">
          external business advisors, such as auditors and lawyers.
        </p>
      </div>
      <h2>
        There are also a limited number of circumstances in which the Privacy
        Act permits us to use or disclose your personal information, without
        your consent. An example of this is where the use or disclosure is
        necessary to prevent a serious and imminent threat to any person's life,
        health or safety or a serious threat to public health or safety.
      </h2>
      <h3>USE OF THIRD PARTY SOFTWARE</h3>
      <h2>
        As at [<span class="red"
          >insert date that this privacy policy is uploaded for use</span
        >], our website uses the following services and technologies that are
        supplied by third parties:
      </h2>
      <div>
        <p>
          [<span class="red"
            >list the names of known third party providers – eg. for electronic
            payment gateways etc</span
          >]
        </p>
        <p>Google Drive</p>
      </div>
      <h2>
        Your personal information may be collected directly by the third party
        providers of the abovementioned services and technologies, when you
        input personal information via our website. You should review the
        privacy policies of third parties who provide those technologies, to
        ensure that you are satisfied with the manner in which they collect,
        manage, store, use and disclose your personal information. Except where
        we state otherwise in this policy, those third parties' dealings in your
        personal information are not subject to our control and we are not
        sponsored, affiliated or associated with those providers.
      </h2>
      <h3>DIRECT MARKETING</h3>
      <h2>
        We may collect, store and use your personal information to market our
        services to you, where you have provided your implied or express consent
        for us to do so. Consent may be implied when you have placed a
        reservation or purchased services from us, joined one of our clubs or
        programs, entered into a promotion conducted by us, where you have
        subscribed to receive information from us or where you have enquired
        about services that we provide.
      </h2>
      <h2>
        You may always opt out of receiving marketing material by contacting our
        Privacy Officer or using the method that is provided in any of our
        electronic marketing communications to you.
      </h2>
      <h2>
        We will not disclose your personal information to a third party for them
        to market their products or services to you, without your consent.
      </h2>
      <h3>CROSS-BORDER DISCLOSURE OF PERSONAL INFORMATION</h3>
      <h2>
        Personal information submitted on this website will be stored on the
        Cloud (that is, the internet). To assist Unifi to store and access your
        personal information on the Cloud, Unifi may store your personal
        information with, or allow it to be accessed by, overseas third parties
        who provide:
      </h2>
      <h4>
        <span class="num">1.</span>software and maintenance services for the
        Cloud;
      </h4>
      <h4>
        <span class="num">2.</span>training services in connection with using
        and accessing the Cloud; and
      </h4>
      <h4>
        <span class="num">3.</span>infrastructure / hardware used to access the
        Cloud.
      </h4>
      <h2>
        As those third parties are situated, and store content, offshore
        (including in jurisdictions such as Belgium, Chile, Denmark, Finland,
        Ireland, Netherlands, Singapore, Taiwan and the United States of
        America), your personal information may be transmitted, disclosed,
        stored or accessed to and from overseas jurisdictions.
      </h2>
      <h2>
        If you submit your personal information on this website, you are
        consenting to the transmission, disclosure, storage and access of your
        personal information by third parties in overseas jurisdictions. In that
        respect, <span class="souwai">APP 8</span> which ordinarily obliges
        Unifi to take reasonable steps to ensure that overseas recipients of
        your personal information do not breach the
        <span class="souwai">APPs</span> (except
        <span class="souwai">APP</span> 1) will not apply.
      </h2>
      <h2>
        Please note that if any of those overseas recipients handle your
        personal information in a manner which is inconsistent, or does not
        comply, with the <span class="souwai">APPs</span>:
      </h2>
      <h4>
        <span class="num">1.</span>to the maximum extent permitted by law, Unifi
        will not be accountable under the
        <span class="souwai">Privacy Act</span> for any resulting loss or damage
        that you may suffer;
      </h4>
      <h4>
        <span class="num">2.</span>to the maximum extent permitted by law, you
        will not be able to seek redress against Unifi under the
        <span class="souwai">Privacy Act</span>;
      </h4>
      <h4>
        <span class="num">3.</span>the overseas recipient may not be subject to
        any privacy obligations at all, or to any principles similar to the
        <span class="souwai">APPs</span>;
      </h4>
      <h2>
        <span class="num">4.</span>you may not be able to seek redress against
        the overseas recipient in their jurisdiction; and
      </h2>
      <h2>
        <span class="num">5.</span>in holding your personal information, the
        overseas recipient may be subject to foreign laws which compel their
        disclosure of your personal information to other parties, such as
        overseas government authorities.
      </h2>
      <h3>HOW DOES UNIFI HOLD AND SECURE YOUR PERSONAL INFORMATION?</h3>
      <h2>
        We will take all reasonable steps to ensure the personal information we
        collect, use, or disclose is accurate, up to date, complete and
        relevant, having regard to the purpose of the collection, use or
        disclosure. You should ensure that any personal information you provide
        to us is both relevant and accurate.
      </h2>
      <h2>
        We have in place user names, passwords and access restrictions that
        provide electronic protection of personal information stored
        electronically. There are inherent risks with the transmission of data
        over the internet. Whilst reasonably appropriate security measures are
        in place for the protection of your personal information, you must be
        aware that no guarantee is made that your personal information is
        completely secure.
      </h2>
      <h2>
        We also secure hard copy personal information within buildings or other
        storage facilities, by placing restrictions on access to those buildings
        or facilities (for example, by locking the buildings and filing cabinets
        in which the personal information is stored).
      </h2>
      <h2>
        In the event of any unauthorised access and/or disclosure of your
        personal information, we comply with our obligations under the Privacy
        Act in dealing with any such unauthorised access and/or disclosure,
        including any obligations which may arise in respect of eligible data
        breaches within the meaning of the
        <span class="souwai">Privacy Act</span>.
      </h2>
      <h3>
        HOW CAN YOU ACCCESS AND SEEK CORRECTION OF YOUR PERSONAL INFORMATION?
      </h3>
      <h2>
        We will deal with your requests for access or correction of your
        personal information, in accordance with this policy.
      </h2>
      <h3>
        All requests must be made in writing, and in the appropriate form
        specified by us from time to time. Within a reasonable timeframe after
        receiving your application, we will take reasonable steps to inform you
        of what personal information we hold.
      </h3>
      <h2>
        We will ordinarily grant access to the personal information unless:
      </h2>
      <div>
        <p>
          giving access would have an unreasonable impact on the privacy of
          other individuals;
        </p>
        <p>the request for access is frivolous or vexatious;</p>
        <p>we are unable to verify your identity;</p>
        <p>
          we are entitled to reject your access to the personal information
          pursuant to any law; or
        </p>
        <p>the access would be unlawful.</p>
      </div>
      <h2>
        We reserve the right to charge a reasonable fee for providing access to
        the personal information, but not for making the application or
        correcting personal information held by us. We may withhold access to
        the personal information until the fee is paid.
      </h2>
      <h2>
        If you are of the view that your personal information requires
        correction, you should contact the Privacy Officer listed below.
      </h2>
      <h3>COMPLAINTS</h3>
      <h2>
        If you believe that we have breached this policy, please contact our
        Privacy Officer by email at team@unifiproperty.com or by mail to:
        Privacy Officer, 54 Prospect Road, Prospect, South Australia 5082. We
        take all complaints seriously and will respond to you within a
        reasonable period of time, unless we consider your complaint to be
        frivolous, vexatious or without legal or factual merit. If you are not
        satisfied with the way in which we have handled your complaint, you can
        make a complaint to the Australian Information Commissioner.
      </h2>
      <h3>MORE INFORMATION</h3>
      <h2 style="margin-bottom:80px">
        If you have any questions or require further information please contact
        our Privacy Officer by e-mail at team@unifiproperty.com
      </h2>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";

export default {
  data() {
    return {
      showTitle: false,
      gray: true
    };
  },
  components: {
    headNav,
    footNav
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  }
};
</script>

<style lang="scss" scoped>
.innerWrapper {
  width: 100%;
  padding: 1.04rem 0 0 0;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 1.04rem 0.24rem 0 0.24rem;

  h1 {
    font-size: 0.56rem;
    line-height: 0.68rem;
    color: #2a2929;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
    padding-top: 0.48rem;
    box-sizing: border-box;
  }

  h2 {
    font-size: 0.28rem;
    margin-bottom: 0.4rem;
    line-height: 0.42rem;
    color: #3f3f46;

    i {
      font-style: italic;
      font-family: ProximaNova-Semibold;
    }

    .souwai {
      font-style: italic;
    }

    .red {
      color: #ff1300;
    }

    .num {
      margin-right: 0.1rem;
      position: relative;
      top: 0.03rem;
    }
  }

  .wai {
    font-style: italic;
  }

  h3 {
    font-size: 0.3rem;
    font-family: ProximaNova-Semibold;
    margin-bottom: 0.3rem;
    line-height: 0.5rem;
    color: #3f3f46;
  }

  h4 {
    font-size: 0.28rem;
    margin-bottom: 0.4rem;
    line-height: 0.42rem;
    color: #3f3f46;
    width: 100%;
    display: flex;
    flex-direction: row;

    .num {
      margin-right: 0.1rem;
      position: relative;
    }

    .souwai {
      font-style: italic;
    }

    .word {
      margin-right: 0.1rem;
    }
  }

  p {
    font-size: 0.28rem;
    margin-bottom: 0.36rem;
    line-height: 0.42rem;
    color: #3f3f46;
    word-break: break-word;
    padding: 0 0.24rem;
    box-sizing: border-box;
    padding-left: 0.58rem;
    position: relative;

    .red {
      color: #ff1300;
    }
  }

  p:after {
    content: "";
    display: block;
    position: absolute;
    left: 0.16rem;
    top: 40%;
    border-radius: 50%;
    width: 0.12rem;
    height: 0.12rem;
    background: rgba(0, 0, 0, 1);
  }

  .suojin {
    padding-left: 1rem;
  }

  .suojin:after {
    left: 0.56rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/more/policy.vue